import 'src/compass/shared/theme/app-theme.scss';

import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// layouts
import { SiteLayout, MenuPageLayout } from 'src/compass/application';
// components
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';
import { CasAuthenticationHOC } from 'src/compass/site/components';
import { paths } from './paths';
import { useCasFilteredNavigation } from './useCasFilteredNavigation';

// ----------------------------------------------------------------------

const HomePage = lazy(() => import('src/compass/pages/home/HomePage'));

function useMenuRoutes() {
  const navData = useCasFilteredNavigation();

  const menuRoutes = navData.map((menu) => ({
    path: menu.path,
    exact: true,
    children: [
      {
        // Giving path as an empty string means it will match the parent path.
        path: '',
        exact: true,
        element: <CasAuthenticationHOC Component={<MenuPageLayout subMenus={menu.subMenus} />} />,
      },
      ...menu.subMenus.map((subMenu) => ({
        path: subMenu.path,
        exact: true,
        element: subMenu.element ? <CasAuthenticationHOC Component={subMenu.element} /> : null,
        children: subMenu.children,
      })),
    ],
  }));

  const additionalRoutes = [
    {
      path: paths.home,
      permissions: ['*'],
      element: (
        <SiteLayout>
          <Suspense fallback={<CasLoader />}>
            <Outlet />
          </Suspense>
        </SiteLayout>
      ),
      children: [
        {
          path: '',
          permissions: ['*'],
          element: <Navigate to={paths.DASHBOARD} replace />,
        },
        {
          path: paths.DASHBOARD,
          permissions: ['*'],
          element: <HomePage />,
        },
        ...menuRoutes,
      ],
    },
  ];

  return additionalRoutes;
}

export default useMenuRoutes;
